import { Api } from "../config/AxiosInstance";

export const getSingleWebsite = async (websiteId) => {
  const { data } = await Api.get(`/singlewebsite/${websiteId}`);
  localStorage.setItem("data", JSON.stringify(data?.data));
  return data;
};
export const getUserId = async (name) => {
  const { data } = await Api.get(`/get_subadmin_details?subadmin_name=${name}`);
  return data;
};

export const getFeature = async (isFeature) => {
  const { data } = await Api.get("/view/featured");
  const filteredData = data?.data?.filter((item) =>
    isFeature ? item.status === "Featured" : item.status !== "Featured"
  );
  return filteredData;
};

export const getWebsiteAndAgentID = async (isFeature) => {
  const { data } = await Api.get("/view/featured");
  const filteredData = data?.data?.filter((item) =>
    isFeature ? item.status === "Featured" : item.status !== "Featured"
  );
  return filteredData;
};

export const getAbout = async (websiteId, agentId) => {
  const { data } = await Api.get(`/view/about_us/${websiteId}/${agentId}`);
  return data?.data;
};

export const getAllBlogs = async (websiteId, agentId) => {
  const { data } = await Api.get(`/view/blog/${websiteId}/${agentId}`);
  return data?.data;
};

export const getSingleBlog = async (id) => {
  const { data } = await Api.get(`/view/single/blog/${id}`);
  return data?.data;
};

export const getContactUs = async (websiteId, agentId) => {
  const { data } = await Api.get(`/view/contact_us/${websiteId}/${agentId}`);
  return data?.data;
};

export const getLogo = async (websiteId, agentId) => {
  const { data } = await Api.get(`/view/logo/${websiteId}/${agentId}`);
  return data?.data;
};

export const getSupplier = async (agentId) => {
  const { data } = await Api.get(
    `/view/user_get_assigned_suppliers/${agentId}`
  );
  return data?.data;
};

export const addMessage = async (values, website_id, agent_id) => {
  try {
    const formData = new FormData();
    formData.append("first_name", values.name);
    formData.append("last_name", values.lastName);
    formData.append("email", values.email);
    formData.append("website_id", website_id);
    formData.append("subadmin_id", agent_id);
    formData.append("phone_no", values.number);
    formData.append("message", values.message);
    const response = await Api.post("/store/user/contact", formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};
